// initial state
// shape: [{ id, quantity }]
const state = () => ({
    links: [
        {
            href: '/v/dashboard',
            name: 'dashboard',
            routerName: 'dashboard',
            icon: 'fas fa-th-list',
            button_add: false,
            function: ["href", 'dashboard'],
            sublinks: [],
            permission: "dashboard.show",
        },
        // {
        //     href: '/v/orders',
        //     name: 'orders',
        //     icon: 'fas fa-file-alt',
        //     button_add : false,
        //     function : ["href", '{{route("invoice.create")}}'],
        //     sublinks : [],
        // },
        // {
        //     href: '/v/invoices',
        //     name: 'invoices',
        //     icon: 'fas fa-file-alt',
        //     button_add : false,
        //     function : ["href", '{{route("invoice.create")}}'],
        //     sublinks : [],
        // },
        {
            // href: '/v/pobox',
            name: 'pobox.title',
            icon: 'fas fa-mail-bulk',
            routerName: 'pobox_inbox',
            routerParams: { filter: "inbox" },
            button_add: false,
            function: [],
            permission: "inbox.show",
            sublinks: [
                {
                    // href: '/v/pobox/filter=inbox',
                    name: 'pobox.inbox',
                    routerName: 'pobox_inbox',
                    routerParams: { filter: "inbox" },
                    icon: 'fas fa-envelope-open-text',
                    button_add: false,
                    function: ["href", '{{route("invoice.create")}}'],
                    sublinks: [],
                },
                {
                    // href: '/v/pobox?filter=sent',
                    name: 'pobox.sent',
                    routerName: 'pobox_sent',
                    routerParams: { filter: "sent" },
                    icon: 'fas fa-paper-plane',
                    button_add: false,
                    function: ["href", '{{route("invoice.create")}}'],
                    sublinks: [],
                },
                {
                    // href: '/v/pobox?filter=outgoing',
                    name: 'pobox.outgoing',
                    routerName: 'pobox_outgoing',
                    routerParams: { filter: "outgoing" },
                    icon: 'fas fa-exchange-alt',
                    button_add: false,
                    function: ["href", '{{route("invoice.create")}}'],
                    sublinks: [],
                }
            ],
        },
                {
                    name: 'external-invoice',
                    routerName: 'externalInvoices',
                    icon: 'fas fa-ruler-combined',
                    permission: "external-invoices.show",
                    button_add: false,
                    function: [],
                    subvisible: false,
                    sublinks: []
                },
        {
            // href: '/v/products',
            name: 'products',
            routerName: 'products',
            icon: 'fab fa-product-hunt',
            button_add: false,
            permission: "products.show",
            function: ["modal", "product"],
            sublinks: [
                {
                    // href: '/v/products',
                    name: 'products',
                    routerName: 'products',
                    icon: '',
                    permission: "products.show",
                    button_add: false,
                    function: [],
                    subvisible: false,
                    sublinks: []
                },
                {
                    // href: '/v/productcategories',
                    name: 'product_categories',
                    routerName: 'productcategories',
                    icon: '',
                    button_add: false,
                    function: ["modal", "productcategorie"],
                    subvisible: false,
                    permission: "categories.show",
                    sublinks: []
                },
                {
                    // href: '/v/pricelists',
                    name: 'pricelists',
                    routerName: 'pricelists',
                    icon: 'fas fa-list',
                    permission: "price_list.show",
                    button_add: false,
                    function: [],
                    subvisible: false,
                    sublinks: []
                },
                {
                    // href: '/v/units',
                    name: 'units',
                    routerName: 'units',
                    icon: 'fas fa-list',
                    permission: "units.show",
                    button_add: false,
                    function: [],
                    subvisible: false,
                    sublinks: []
                },
                {
                    // href: '/v/currencies',
                    name: 'currencies',
                    routerName: 'currencies',
                    icon: 'fas fa-list',
                    permission: "currencies.show",
                    button_add: false,
                    function: [],
                    subvisible: false,
                    sublinks: []
                },
                {
                    name: 'dimension-types',
                    routerName: 'dimensionTypes',
                    icon: 'fas fa-ruler-combined',
                    permission: "dimension-types.show",
                    button_add: false,
                    function: [],
                    subvisible: false,
                    sublinks: []
                },
            ]
        },
        {
            // href: '/v/companies',
            name: 'companies',
            routerName: 'companies',
            icon: 'fas fa-city',
            permission: "companies.show",
            button_add: false,
            function: ["modal", "company"],
            sublinks: []
        },
        {
            // href: '/v/logistics#s',
            name: 'claims.title',
            icon: 'fab fa-teamspeak',
            routerName: 'claims.index',
            button_add: false,
            permission: "claims.show",
            sublinks: [
                {
                    href: '/claims/',
                    name: 'claims.index',
                    routerName: 'claims.index',
                    routerParams: { type: "koois" },
                    icon: 'fas fa-tags',
                    button_add: false,
                    subvisible: false,
                    sublinks: [],
                    permission: "claims.show",
                },
            ]
        },
        {
            // href: '/v/logistics#s',
            name: 'reporting.title',
            icon: 'fas fa-chart-bar',
            button_add: false,
            sublinks: [
                {
                    href: '/reporting/koois',
                    name: 'reporting.koois',
                    routerName: 'reporting.type',
                    // permission : "logistics.show",
                    routerParams: { type: "koois" },
                    icon: 'fas fa-handshake',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/invoices',
                    name: 'reporting.invoices',
                    routerName: 'reporting.invoices',
                    // permission : "logistics.show",
                    // routerParams: { type: "invoices"},
                    icon: 'fas fa-chart-area',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/purchases',
                    name: 'reporting.purchases',
                    routerName: 'reporting.type',
                    // permission : "logistics.show",
                    routerParams: { type: "purchases" },
                    icon: 'fas fa-handshake',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/contracts',
                    name: 'reporting.contracts',
                    routerName: 'reporting.type',
                    // permission : "logistics.show",
                    routerParams: { type: "contracts" },
                    icon: 'fas fa-comments',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/customers',
                    name: 'reporting.customers',
                    routerName: 'reporting.type',
                    // permission : "logistics.show",
                    routerParams: { type: "customers" },
                    icon: 'fas fa-luggage-cart',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/suppliers',
                    name: 'reporting.suppliers',
                    routerName: 'reporting.type',
                    // permission : "logistics.show",
                    routerParams: { type: "suppliers" },
                    icon: 'fas fa-cart-plus',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/product_statistic',
                    name: 'reporting.products',
                    routerName: 'reporting.type',
                    // permission : "logistics.show",
                    routerParams: { type: "product_statistic" },
                    icon: 'fas fa-project-diagram',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/product_contract_statistic',
                    name: 'reporting.product_contract_statistic',
                    routerName: 'reporting.type',
                    // permission : "logistics.show",
                    routerParams: { type: "product_contract_statistic" },
                    icon: 'fas fa-project-diagram',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/profit/list',
                    name: 'reporting.profit',
                    routerName: 'reporting.profit',
                    // permission : "logistics.show",
                    routerParams: { type: "profit" },
                    icon: 'fas fa-chart-line',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/provisions/show',
                    name: 'reporting.provisions',
                    routerName: 'reporting.provisions',
                    // permission : "logistics.show",
                    routerParams: { type: "provisions" },
                    icon: 'fas fa-chart-pie',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/adjustment_calculations/show',
                    name: 'reporting.adjustment_calculations',
                    routerName: 'reporting.adjustment_calculations',
                    permission : "adjustment_calculations.show",
                    routerParams: { type: "adjustment_calculations" },
                    icon: 'fas fa-square-root-variable',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/rebate/show',
                    name: 'reporting.rebate',
                    routerName: 'reporting.rebate',
                    // permission : "logistics.show",
                    routerParams: { type: "rebate" },
                    icon: 'fas fa-arrow-right-arrow-left',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/logistics',
                    name: 'reporting.logistics',
                    routerName: 'reporting.type',
                    // permission : "logistics.show",
                    routerParams: { type: "logistics" },
                    icon: 'fas fa-luggage-cart',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    href: '/reporting/logistics_chain',
                    name: 'reporting.logistics_chain',
                    routerName: 'reporting.type',
                    // permission : "logistics.show",
                    routerParams: { type: "logistics_chain" },
                    icon: 'fas fa-luggage-cart',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                           {
                    href: '/reporting/issues/possible_issues/show',
                    name: 'reporting.possible_issues',
                    routerName: 'reporting.possible_issues',
                    // permission : "logistics.show",
                    routerParams: { type: "possible_issues" },
                    icon: 'fas fa-arrow-right-arrow-left',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                        {
                    href: '/reporting/reporting_rechnungsausgangsliste',
                    name: 'reporting.reporting_rechnungsausgangsliste',
                    routerName: 'reporting.type',
                    // permission : "logistics.show",
                    routerParams: { type: "reporting_rechnungsausgangsliste" },
                    icon: 'fas fa-arrow-right-arrow-left',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },


            ]
        },
        {
            name: 'base-reports',
            permission : "base-report.show",
            icon: 'fas fa-luggage-cart',
            button_add: false,
            subvisible: false,
            sublinks: [

                {
                href: '/reporting/invoices_overview',
                name: 'reporting.invoices_overview',
                routerName: 'reporting.invoices-overview',
                permission : "base-report.show",
                routerParams: { },
                icon: 'fas fa-luggage-cart',
                button_add: false,
                subvisible: false,
                sublinks: []
            },]
        },
        {
            name: 'settings',
            icon: 'fas fa-cog',
            button_add: false,
            sublinks: [
                {
                    href: '/v/logistics',
                    name: 'logistics',
                    routerName: 'logistics',
                    permission: "logistics.show",
                    icon: 'fas fa-bacon',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    // href: '/v/conditions',
                    name: 'conditions',
                    routerName: 'conditions',
                    permission: "conditions.show",
                    icon: 'fas fa-bacon',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    // href: '/v/textblocks',
                    name: 'textblocks',
                    routerName: 'textblocks',
                    permission: "textblocks.show",
                    icon: 'fas fa-bacon',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    // href: '/v/countries',
                    name: 'countries',
                    routerName: 'countries',
                    permission: "countries.show",
                    icon: 'fas fa-flag',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    // href: '/v/emailtemplates',
                    name: 'email_templates',
                    routerName: 'email_templates',
                    permission: "e-mail-templates.show",
                    icon: 'fas fa-envelope-open-text',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    // href: '/v/pdf-translations',
                    name: 'pdf-translations',
                    routerName: 'pdf_translations',
                    permission: "pdf-translation.show",
                    icon: 'fas fa-language',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    // href: '/v/pdf-translations',
                    name: 'popups',
                    routerName: 'popups.index',
                    permission: "popups.edit",
                    icon: 'fas fa-radiation',
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
                {
                    // href: '/v/system-settings',
                    name: 'system',
                    routerName: 'system_settings',
                    icon: 'fas fa-cog',
                    permission: "system_settings.show",
                    button_add: false,
                    subvisible: false,
                    sublinks: []
                },
            ]
        },
        {
            // href: '/v/admin',
            name: 'admin_settings',
            icon: 'fas fa-city',
            button_add: false,
            permission: "system_settings.show",
            function: [],
            sublinks: [
                {
                    // href: '/v/user_managment',
                    name: 'users',
                    routerName: 'users',
                    icon: 'fas fa-user',
                    permission: "users.show",
                    button_add: false,
                    sublinks: []
                },
                {
                    name: 'roles',
                    routerName: 'permission_roles.index',
                    permission: 'groups.show',
                    icon: 'fas fa-users',
                    button_add: false,
                    sublinks: [],
                },
                {
                    // href: '/v/group_managment',
                    name: 'groups',
                    routerName: 'permission_groups.index',
                    permission: "groups.show",
                    icon: 'fas fa-users',
                    button_add: false,
                    sublinks: []
                },
                {
                    // href: '/v/group_managment',
                    name: 'tablecolumns',
                    routerName: 'table-columns.index',
                    permission: "table-columns.index",
                    icon: 'fas fa-table',
                    button_add: false,
                    sublinks: []
                },
                {
                    // href: '/v/group_managment',
                    name: 'registry',
                    routerName: 'settings.registry',
                    permission: "registry.show",
                    icon: 'fas fa-table',
                    button_add: false,
                    sublinks: []
                },

            ]
        },
        // {
        //     href: '/logout',
        //     name: 'logout',
        //     routerName: 'dashboard',
        //     icon: 'fas fa-sign-out-alt',
        //     button_add : false,
        //     function : ["modal", "company"] ,
        //     sublinks : []
        // },
    ],
    minimized: false,
})

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
    sidebarMinimize(state, event) {
        state.minimized = !state.minimized;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
